const privateStoragePrefixes = ['ddone.filters.', 'ddone.layout.', 'ddone.recent.', 'ddone.draft.'];

export async function purgePrivateBrowserData(): Promise<void> {
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (key && privateStoragePrefixes.some((prefix) => key.startsWith(prefix))) {
      localStorage.removeItem(key);
    }
  }
  sessionStorage.clear();
  if (typeof indexedDB !== 'undefined' && 'databases' in indexedDB) {
    const databases = await indexedDB.databases();
    await Promise.all(
      databases
        .map((database) => database.name)
        .filter((name): name is string => Boolean(name?.startsWith('ddone-collab-')))
        .map(
          (name) =>
            new Promise<void>((resolve) => {
              const request = indexedDB.deleteDatabase(name);
              request.onsuccess = () => resolve();
              request.onerror = () => resolve();
              request.onblocked = () => resolve();
            })
        )
    );
  }
}
